/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import { Image, FlatList, Text, Pressable, View, SafeAreaView } from 'react-native';
import {Loader, CatalogCard} from '../../components';
import styles from './styles';
import { Firestore, Crashlytics } from '../../firebase/config';
import { useRoute } from '@react-navigation/native';
import TextTicker from 'react-native-text-ticker';


export default function AllCatalogs(props) {
    const [loading, setLoading] = useState(true)
    const [catalogs, setCatalogs] = useState([]);
    const [announcement, setAnnouncement] = useState(null);
    const { navigation } = props;
    const route = useRoute();
    const allCatalogsRef = Firestore.collection('Files').doc('Catalogs').collection('Empire Catalogs');
    Firestore.collection('Updates');
    Firestore.collection('users');
    const announcementsRef = Firestore.collection('Announcements');
    //const lastUpdateFetch = props.extraData.user.lastUpdateFetch.timestamp;
    //const unreadUpdates = props.extraData.user.unreadCounter;
    const emptyListNoNetwork = () => {
        return (
            <View style={styles.emptyListNoNetwork}>
                <Image
                    style={{resizeMode: 'contain'}}
                    source={require('../../../assets/iconOffline.png')}
                />
                <Text style={styles.emptyListNoNetworkText}>Check Internet Connection</Text>
            </View>
        )
    }
    const renderCatalog = ({item, index}) => {
        return (
            <CatalogCard
                id={item.id}
                onPress={props.extraData.user? () => navigation.navigate('Catalog', {catalog: item.id}) : () => navigation.navigate('ViewCatalog', {catalogID: item.id})}
                title={item.title}
                image={item.image}
                description={item.description}
                unread={item.unread}
            />
        )
    }

    //Gets Announcements
useEffect(() => {
    console.log(`Getting Announcements...`)
    function onResult(document) {
        console.log(`Document: ${JSON.stringify(document.data())}`)
        if (document.data().enabled) {
            console.log(document.data())
            setAnnouncement(document.data());
        }
        else {
            setAnnouncement(null);
        }
    }
    function onError(e) {
        console.error(`Error getting announcements: ${e}`);
        Crashlytics.recordError(e);
    }
    const ref = props.extraData.user? (announcementsRef.doc('allUsers')):(announcementsRef.doc('Public'));
    const task = ref.onSnapshot(onResult, onError);
    return task;
},[])

    //Public
    if (!props.extraData.user) {
        console.log(`No User Signed In!`)
    const getCatalogs = () => {
        console.log(`Getting Catalogs...`)
        function onResult(querySnapshot) {
            const allCatalogs = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                data.id = doc.id;
                data.unread = 0;
                allCatalogs.push(data);
            });
            setCatalogs(allCatalogs);
            setLoading(false);
        }
        function onError(e) {
            console.error(`Error fetching catalogs ${e}`);
            Crashlytics.recordError(e);
        }
        const task = allCatalogsRef.where('visibility', '==', 'public').onSnapshot(onResult, onError);
        return () => task;
    }

    useEffect(() => {
        getCatalogs();
    },[]);

        return (
            <SafeAreaView style={styles.container}>
                {catalogs && (
                    <>
                        {announcement && (
                            <View style={[styles.announcementContainer,{backgroundColor: announcement.bannerBackgroundColor, width: "100%"}]}>
                                <TextTicker
                                    style={{ fontSize: announcement.fontSize }}
                                    duration={announcement.duration}
                                    loop
                                    bounce
                                    repeatSpacer={announcement.repeatSpacer}
                                    marqueeDelay={announcement.marqueeDelay}
                                >
                                    <Text style={{color: announcement.textColor}}>{announcement.text}</Text>
                                </TextTicker>
                            </View>
                        )}
                        <FlatList
                            data={catalogs}
                            renderItem={renderCatalog}
                            keyExtractor={(item) => item.id}
                            removeClippedSubviews={true}
                            showsVerticalScrollIndicator={false}
                            showsHorizontalScrollIndicator={false}
                            ListEmptyComponent={emptyListNoNetwork}
                        />
                    </>
                )}
            </SafeAreaView>
        )
    }
    const productLines = props?.extraData?.productLines;
    const lastUpdateFetch = props.extraData.user.lastUpdateFetch.timestamp;
    const unreadUpdates = props.extraData.user.unreadCounter;

 function getUnreadUpdatesforProductLine(productLine) {
if (productLine in unreadUpdates) {
return unreadUpdates[productLine];
}
 else {
 return 0;
 }
 }

/*useEffect(() => {
    if (unreadUpdates && unreadUpdates.totalUnreadCount <= 0) {
    setBadgeCount(0);
    navigation.setOptions({
    headerRight: () => (
    <View style={{position: 'absolute', right: 15}}>
    <Pressable
    onPress={() => {
    navigation.navigate('Activity Feed', {catalogID: null})}}>
    <Icon
    name='fireplace'
    type='material-community'
    color='lightgray'
    size={30}
    />
    </Pressable>
    </View>
    ),
    })
    }
    else if (unreadUpdates) {
        let unreadCount = 0;
    if (Number(unreadUpdates.totalUnreadCount) >= 99) {
    unreadCount = "99+";
    }
    else {
     unreadCount = unreadUpdates.totalUnreadCount;
    }
    setBadgeCount(unreadUpdates.totalUnreadCount);
    navigation.setOptions({
        headerRight: () => (
        <View style={{ position: 'absolute', right: 15}}>
        <Pressable
        onPress={() => {
        navigation.navigate('Activity Feed')}}>
        <Icon
        name='fireplace'
        type='material-community'
        color='lightgray'
        size={30}
        />
        <Badge value={unreadCount} containerStyle={{position: 'absolute', top: -5, right: -10, width: 30 }} status="error" />
        </Pressable>
        </View>
        ),
        })
    }
    },[unreadUpdates, lastUpdateFetch]);*/


      //Gets Catalogs
            useEffect(() => {
            if (lastUpdateFetch) {
               const subscriber = allCatalogsRef
                .where('productLine', 'in', productLines)
                .orderBy('z-index', 'asc')
                    .onSnapshot(
                        querySnapshot => {
                            const allCatalogs = []
                            querySnapshot.forEach(doc => {
                                const catalog = {
                                image: doc.data().image,
                                flipbook: doc.data().flipbook,
                                title: doc.data().title,
                                description: doc.data().description,
                                productLine: doc.data().productLine,
                                }
                                catalog.id = doc.id
                                catalog.unread = getUnreadUpdatesforProductLine(doc.data().productLine)
                                allCatalogs.push(catalog)
                            });
                            setCatalogs(allCatalogs)
                            setLoading(false);
                        },
                        error => {
                        console.error("Error getting catalogs: ", error);
                        Crashlytics.recordError(error);
                            setLoading(false)
                        }
                    )
                    return () => subscriber();
            }}, [unreadUpdates, lastUpdateFetch, productLines, route]);

            function setBadgeCount(count) {
            //return Notifications.setBadgeCountAsync(count);
            }



  if (loading) {
    return (
    <Loader />
    )
  }


    return (
            <SafeAreaView style={styles.container}>
                {catalogs.length && (
                <>
                {announcement && (
                <View style={[styles.announcementContainer,{backgroundColor: announcement.bannerBackgroundColor, width: "100%"}]}>
                 <TextTicker
                  style={{ fontSize: announcement.fontSize }}
                  duration={announcement.duration}
                  loop
                  bounce
                  repeatSpacer={announcement.repeatSpacer}
                  marqueeDelay={announcement.marqueeDelay}
                  >
                  <Text style={{color: announcement.textColor}}>{announcement.text}</Text>
                  </TextTicker>
                  </View>
                )}
                        <FlatList
                            data={catalogs}
                            renderItem={renderCatalog}
                            keyExtractor={(item) => item.id}
                            removeClippedSubviews={true}
                            showsVerticalScrollIndicator={false}
                            showsHorizontalScrollIndicator={false}
                            ListEmptyComponent={emptyListNoNetwork}
                        />
                    </>
                )}
            </SafeAreaView>
        )
        }